import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Const } from '../static/const';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { TextClaim } from '../models/text-claim.model';
import { Converters } from '../static/converters';
import { Document } from '../../app/models/document.model';
import { DocumentType } from '../../app/static/document-type.enum';
import { ImageFile } from '../models/image-file.model';
import * as _ from 'lodash';
import { ImageDetectionResponse } from '../models/image-detection.model';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  public iraResetFunction: (() => void) | null = null;
  public iraFormatFunction: (() => void) | null = null;
  public iraSaveAssetFunction: (() => void) | null = null;
  public iraExportExcelFunction: (() => void) | null = null;
  public iraExportPdfFunction: (() => void) | null = null;
  public iraSaveasExcelFunction: (() => void) | null = null;
  public irasaveasPdfFunction: (() => void) | null = null;

  setIraResetFunction(fn: () => void) {
    this.iraResetFunction = fn;
  }

  callIraResetFunction() {
    if (this.iraResetFunction) {
      this.iraResetFunction();
    }
  }
  setIraFormatQualifierFunction(fn: () => void) {
    this.iraFormatFunction = fn;
  }

  callIraFormatQualifierFunction() {
    if (this.iraFormatFunction) {
      this.iraFormatFunction();
    }
  }
  setIraSaveAssetFunction(fn: () => void) {
    this.iraSaveAssetFunction = fn;
  }
  callIraSaveAssetFunction() {
    if (this.iraSaveAssetFunction) {
      this.iraSaveAssetFunction();
    }
  }

  setIraExportPdfFunction(fn: () => void) {
    this.iraExportPdfFunction = fn;
  }
  callIraExportPdfFunction() {
    if (this.iraExportPdfFunction) {
      this.iraExportPdfFunction();
    }
  }

  setIraExportExcelFunction(fn: () => void) {
    this.iraExportExcelFunction = fn;
  }
  callIraExportExcelFunction() {
    if (this.iraExportExcelFunction) {
      this.iraExportExcelFunction();
    }
  }

  setIraSaveasPdfFunction(fn: () => void) {
    this.irasaveasPdfFunction = fn;
  }
  callIraSaveaspdfFunction() {
    if (this.irasaveasPdfFunction) {
      this.irasaveasPdfFunction();
    }
  }

  setIraSaveasExcelFunction(fn: () => void) {
    this.iraSaveasExcelFunction = fn;
  }
  callIraSaveasExcelFunction() {
    if (this.iraSaveasExcelFunction) {
      this.iraSaveasExcelFunction();
    }
  }

  clear() {
    this.iraResetFunction = null;
    this.iraFormatFunction = null;
    this.iraSaveAssetFunction = null;
    this.iraExportExcelFunction = null;
    this.iraExportPdfFunction = null;
    this.iraSaveasExcelFunction = null;
    this.irasaveasPdfFunction = null;
  }

  excelBase64 = new BehaviorSubject<any>(null);
  curentBase64 = this.excelBase64.asObservable();

  marketingChannels = new BehaviorSubject<any>([]);
  selectedMarketingChannels = this.marketingChannels.asObservable();

  documentDetails = new BehaviorSubject<any>({});
  currentDocumentDetails = this.documentDetails.asObservable();

  assetSubject = new BehaviorSubject<any>('');
  data$ = this.assetSubject.asObservable();

  languageSubject = new BehaviorSubject<any>('');
  languageData$ = this.languageSubject.asObservable();

  
 assetSavedSubject = new BehaviorSubject<boolean>(false);
  assetSaved$ = this.assetSavedSubject.asObservable();

  
  constructor(private http: HttpClient) {}

  
  getExcelBase64(base64: any) {
    this.excelBase64.next(base64);
  }

  updateValue(newValue: any[]) {
    this.assetSubject.next(newValue);
  }

  gelLangaugeDetails(language: any) {
    this.languageSubject.next(language);
  }

  //to set the status as asset saved
setAssetSaved(saved: boolean) {
    this.assetSavedSubject.next(saved);
  }

  //to check whether the asset is saved
  isAssetSaved(): boolean {
    return this.assetSavedSubject.getValue();
  }


  getMetaData(data: any) {
    const apiUrl = Const.connectionUrl + '/api/begin_here';
    return this.http.post(apiUrl, data);
  }

  postDocumentData(document: any) {
    const apiUrl = Const.connectionUrl + '/api/setDocument';
    return this.http.post(apiUrl, document);
  }

  getDocumentData() {
    const apiUrl = Const.connectionUrl + '/api/getDocument';
    return this.http.get(apiUrl);
  }

  checkDuplicatesData(data: any) {
    const apiUrl = Const.connectionUrl + '/api/check_duplicates';
    return this.http.post(apiUrl, data);
  }

  checkExistingVeevaData(data: any) {
    const apiUrl = Const.connectionUrl + '/api/check_exist';
    return this.http.post(apiUrl, data);
  }

  //image detection
  detectImage(document: Document, pageNumber: number): Observable<any> {
    const imageFile = _.first(this.getImages(document, pageNumber));
    console.log('img file', imageFile);
    return this.getEeocImageDetections(imageFile);
  }

  private getImages(document: Document, pageNumber?: number): ImageFile[] {
    if (document.type === DocumentType.TEXT) {
      return [];
    }
    if (document.type === DocumentType.IMAGE) {
      return [
        {
          base64: document.pages[0].image!,
          blob: document.file!,
          fileName: document.file?.name!,
        },
      ];
    }

    if (pageNumber != null) {
      const page: any = document.pages[pageNumber];
      return [
        {
          base64: page.image,
          blob: Converters.dataURItoBlob(page.image),
          fileName: this.getPageFileName(document.file?.name!, pageNumber),
        },
      ];
    }
    return document.pages.map<ImageFile>((page: any, index: any) => {
      return {
        base64: page.image,
        blob: Converters.dataURItoBlob(page.image),
        fileName: this.getPageFileName(document.file?.name!, index),
      };
    });
  }

  public getTexts(document: Document): any[] {
    return document.pages.map<any>((page: any, index: any) => {
      const textClaims: TextClaim[] = [];
      if (page.textClaims.length) {
        for (let i = 0; i < page.textClaims.length; i++) {
          textClaims.push(page.textClaims[i].text);
        }
        page.textValues = textClaims;
        return page.textValues;
      } else {
        return (page.textValues = []);
      }
    });
  }

  private getPageFileName(fileName: string, pageNumber: number): string {
    if (fileName == null || fileName.length === 0) {
      return `${pageNumber + 1}.jpeg`;
    }
    const index = fileName.lastIndexOf('.');
    if (index >= 0) {
      return `${fileName.substring(0, index)}_${pageNumber + 1}.jpeg`;
    } else {
      return `${fileName}_${pageNumber + 1}.jpeg`;
    }
  }

  //function to extract text from image in EEOC
  getEeocImageDetections(file: ImageFile): Observable<ImageDetectionResponse> {
    const headers = new HttpHeaders();

    const data = {
      image_bytes: file.base64.split(',')[1],
      environment: localStorage.getItem('environment'),
      application: 'EEOC',
    };
    const url = Const.connectionUrl + '/api/image_segmentor';
    return this.http.post(url, data, { headers: headers }).pipe(
      tap(
        (res: ImageDetectionResponse) => {
          res.results = res.results || [];
        },
        (err) => {
          // this.handleHttpError(err);
          // throwError(err);
        }
      )
    );
  }
  checkGlobalClaimLA(data) {
    const url = Const.connectionUrl + '/api/check_global_claims_la';
    return this.http.post(url, data);
  }

  getDraftData(data: any) {
    const apiUrl = Const.connectionUrl + '/api/get_draftlogs';
    return this.http.post(apiUrl, data, { observe: 'response' });
  }

  fetchDraftData(data: any) {
    const apiUrl = Const.connectionUrl + '/api/fetch_savedraft';
    return this.http.post(apiUrl, data);
  }

  saveDraftData(data: any,options?: any) {
    const apiUrl = Const.connectionUrl + '/api/save_draft';
    return this.http.post(apiUrl, data, options);
  }

  private routeDataSubject = new BehaviorSubject<any>(null);
  routeData$ = this.routeDataSubject.asObservable();

  setRouteData(data: any) {
    this.routeDataSubject.next(data);
  }

  getRouteData() {
    return this.routeDataSubject.getValue();
  }
}
